import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from './routes';
import { useDisplayPrefs } from './state/DisplayPrefs';
import { vars } from './styles/theme.css';

export default function App() {
  const { pathname } = useLocation();
  const { showFurigana } = useDisplayPrefs();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return (
    <div
      className={`min-h-screen ${showFurigana ? '' : 'no-furigana'}`}
      style={{
        backgroundColor: vars.color.bg,
        color: vars.color.ink,
        fontFamily: vars.font.body,
      }}
    >
      <AppRoutes />
    </div>
  );
}
